export { default } from './PromotionsContainer';
